module.exports = __webpack_public_path__ + "img/鱼.573f10f4.png";